import {
  SIDE_NAV_WIDTH,
  SIDE_NAV_COLLAPSED_WIDTH,
  NAV_TYPE_TOP,
} from 'constants/ThemeConstant'
import { APP_NAME, LOGO_IMAGE } from 'configs/AppConfig'
import { useSelector } from 'react-redux'
import utils from 'utils'
import { Grid } from 'antd'

const { useBreakpoint } = Grid

export const Logo = ({ mobileLogo, logoType }) => {
  const isMobile = !utils.getBreakPoint(useBreakpoint()).includes('lg')
  const navCollapsed = useSelector((state) => state.theme.navCollapsed)
  const navType = useSelector((state) => state.theme.navType)
  const { adminSettings } = useSelector((state) => state.auth)

  const getLogoWidthGutter = () => {
    const isNavTop = navType === NAV_TYPE_TOP
    if (isMobile && !mobileLogo) {
      return 0
    }
    if (isNavTop) {
      return 'auto'
    }
    if (navCollapsed) {
      return `${SIDE_NAV_COLLAPSED_WIDTH}px`
    }
    return `${SIDE_NAV_WIDTH}px`
  }

  const isNavTop = navType === NAV_TYPE_TOP
  const isCollapsedSlot = navCollapsed && !isNavTop && !isMobile
  const logoSmPath = `/img/logo/${process.env.REACT_APP_CLIENT_NAME}/logo-sm.svg`

  const getLogo = () => {
    if (adminSettings?.logo) {
      return adminSettings.logo
    }

    if (logoType === 'light') {
      if (navCollapsed) {
        return '/img/logo-sm-white.png'
      }
      return '/img/logo-white.png'
    }

    if (isCollapsedSlot) {
      return logoSmPath
    }

    return LOGO_IMAGE
  }

  const logoClassName = [
    'logo',
    isCollapsedSlot ? 'logo--collapsed' : '',
    isMobile && !mobileLogo ? 'd-none' : '',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div
      className={logoClassName}
      style={{ width: `${getLogoWidthGutter()}` }}
    >
      <img
        style={{ width: '100%', display: 'block', maxHeight: '60px' }}
        src={getLogo()}
        alt={`${APP_NAME} logo`}
        className="logo-image-nav"
      />
    </div>
  )
}

export default Logo
